import styled from 'styled-components'
import { theme } from '@provi/provi-components'

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 4000;
  padding: 16px;
`

export const Modal = styled.div`
  background: white;
  border-radius: 20px;
  width: min(520px, 100%);
  max-height: 90vh;
  overflow-y: auto;
  padding: 24px 28px 32px;
  box-shadow: 0px 24px 64px rgba(15, 23, 42, 0.25);

  ${theme.breakpoints.down('sm')} {
    border-radius: 16px;
    padding: 20px;
  }
`

export const Header = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 12px;
`

export const Title = styled.h2`
  font-family: 'Montserrat', sans-serif;
  font-size: 20px;
  margin: 0;
  color: #262626;
`

export const CloseButton = styled.button`
  background: transparent;
  border: none;
  font-size: 28px;
  line-height: 1;
  cursor: pointer;
  color: #64748b;

  &:hover {
    color: #0f172a;
  }
`

export const Description = styled.p`
  font-family: 'Inter', 'Montserrat', sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0;
  color: #262626;
  margin: 0 0 24px;
`

export const TotalsCard = styled.div`
  background: #eef2ff;
  border-radius: 18px;
  padding: 18px 24px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 28px;
  font-family: 'Inter', 'Montserrat', sans-serif;
`

export const TotalsRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const TotalsLabel = styled.span`
  font-size: 15px;
  font-weight: ${({ $highlight }) => ($highlight ? '700' : '400')};
  color: #1f2933;
`

export const TotalsValue = styled.span`
  font-size: 15px;
  font-weight: ${({ $highlight }) => ($highlight ? '700' : '500')};
  color: #1f2933;
`

export const InstallmentsSection = styled.div`
  .section-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;
    font-family: 'Inter', 'Montserrat', sans-serif;
    font-size: 20px;
    font-weight: 600;
    color: #0f172a;
  }
`

export const InstallmentCard = styled.div`
  border: 1px solid #eff3fa;
  border-radius: 16px;
  padding: 18px 20px;
  margin-bottom: 16px;
  background: white;
  box-shadow: 0 2px 4px rgba(15, 23, 42, 0.05);
`

export const InstallmentHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 14px;
  font-family: 'Inter', 'Montserrat', sans-serif;

  ${theme.breakpoints.down('sm')} {
    flex-wrap: wrap;
  }
`

export const InstallmentLabel = styled.span`
  font-size: 15px;
  font-weight: 600;
  color: #0f172a;
  margin-right: 8px;
`

export const InstallmentAmount = styled.span`
  font-size: 15px;
  font-weight: 500;
  color: #0f172a;
`

export const InstallmentDaysOverdue = styled.span`
  font-size: 13px;
  font-weight: 500;
  color: #b42318;
  white-space: nowrap;
`

export const InstallmentDaysDue = styled.span`
  font-size: 13px;
  font-weight: 500;
  color: #0b74de;
  white-space: nowrap;
`

export const StatusBadge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 600;
  color: ${({ $variant }) => ($variant === 'overdue' ? '#B42318' : $variant === 'paid' ? '#15803d' : '#0B74DE')};
  background: ${({ $variant }) => ($variant === 'overdue' ? '#FEE4E2' : $variant === 'paid' ? '#dcfce7' : '#E0ECFF')};
  border-radius: 999px;
  padding: 4px 12px;
  margin-left: 6px;
`

export const ChevronButton = styled.button`
  background: transparent;
  border: none;
  width: 32px;
  height: 32px;
  border-radius: 999px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #475569;
  cursor: pointer;
  transform: ${({ $expanded }) => ($expanded ? 'rotate(180deg)' : 'rotate(0deg)')};
  transition: transform 0.2s ease;
  margin-left: auto;

  &:hover {
    color: #1d4ed8;
  }
`

export const InstallmentDetails = styled.div`
  border-top: 1px solid #e7ebf3;
  padding-top: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const DetailRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
  font-family: 'Inter', 'Montserrat', sans-serif;
`

export const DetailLabel = styled.span`
  font-size: 14px;
  color: #1f2933;
`

export const DetailValue = styled.span`
  font-size: 14px;
  font-weight: 400;
  color: #0f172a;
`

export const DetailHelper = styled.span`
  display: inline;
  font-size: 12px;
  color: #b42318;
  margin-left: 8px;
`

export const ShowAllButton = styled.button`
  background: transparent;
  border: none;
  font-size: 13px;
  color: #2563eb;
  cursor: pointer;

  &:hover {
    color: #1d4ed8;
  }
`
